import type { MetadataEntity } from '../metadata-entity';

import { Property, PropertyMetadataMapper } from './property-metadata.decorator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Label(label: string | null): PropertyMetadataMapper {
	return function(model: MetadataEntity, property: string): void {
		Property({ label })(model, property);
	};
}
